import React from 'react';
import { connect } from "react-redux";
import { PieChart } from '../../../components/charts';
import { Tooltip } from '@mui/material';
import MaterialSymbol from '../../../components/icons/material-symbol';
import { Loading } from "../../../redux/action";
import Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';

Highcharts3D(Highcharts);

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  data: any[]; // Array of influencer data
}

// Dynamic color map based on influencer type
const typeColorMap: Record<string, string> = {
  "Nano": "#D379F0",
  "Micro": "#FEB918",
  "Micro Plus": "#288CFF",
  "Macro": "#34E39A",
  "Macro Plus": "#978D58",
  "Mega": "#FF644F",
  "Mega Plus": "#18587A"
};


const EngagedInfluencers: React.FC<Props> = (props: Props) => {

  const generateChartData = (dataArr: any[]) => {
    return dataArr
      .filter(item => item.influencer_count > 0) // ensure we skip types with 0 count
      .map(item => ({
        name: item.influencer_type,
        y: item.influencer_count,
        color: typeColorMap[item.influencer_type] || "#CCCCCC"
      }));
  };

  

  return (
    <div className="d-flex flex-column infl-engg-common-bg">
      <div className="row col-12 p-0 m-0">
        {props?.data && props?.data.length > 0 && (
          <div className="infl-engg-ratio" style={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
            <div className="d-flex flex-column w-100">
              <span className="text-center pb-2" style={{ fontWeight: '400', fontSize: '16px', color: '#3B5763', lineHeight: '16.99px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className='infl-engg-ratio-title'>Influencers Engagement Ratio</span>
                <Tooltip title="A comparison chart of all types of influencers engaged by the brand." arrow>
                  <span className='ms-1'><MaterialSymbol iconName='info' fontweight='200' /></span>
                </Tooltip>
              </span>

              <PieChart
                showToggle={false}
                zMin={0}
                height={300}
                size='90%'
                innerSize="70%"
                showInLegend={false}
                itemMarginTop={0}
                spacingBottom={0}
                marginBottom={0}
                marginTop={10}
                dataSource={generateChartData(props.data)}
                  options={{
                  tooltip: {
                    pointFormat: '<b>{point.y}</b>' // show raw value on hover
                  }
                }}

              />
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  UserReducer: state.UserReducer.UserData,
});

const mapDispatchToProps = (dispatch: any) => ({
  loading: (data: any) => dispatch(Loading(data)),
});

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(EngagedInfluencers);
export { connectToRedux as EngagedInfluencers };
